module.exports = __webpack_public_path__ + "static/media/memorias_familiares.e9969d39.jpg";